import { Link, useLocation } from 'react-router-dom';
import { NotFoundView } from './NotFoundView';
import { btnPrimary, btnSecondary } from './styles';
import { ADMIN_BASE } from '../../utils/hosts';
type Props = {
  /** Bijv. "Klant niet gevonden" of "Dossier niet gevonden". */
  title: string;
  back: {
    to: string;
    label: string;
  };
  text?: string;
};

/** Voor een editor of dossier waarvan het item niet (meer) bestaat. */
export function MissingItem({
  title,
  back,
  text = 'Misschien is het verwijderd, nog niet opgeslagen, of is de link veranderd.'
}: Props) {
  const {
    pathname
  } = useLocation();
  return <NotFoundView title={title} text={text} path={pathname} actions={<>
          <Link to={back.to} className={btnPrimary} data-id="element-5079" data-mp="3vsehnspa47jx">
            {back.label}
          </Link>
          <Link to={ADMIN_BASE} className={btnSecondary} data-id="element-5080" data-mp="2yd0j7xpv4b14">
            Naar het overzicht
          </Link>
        </>} data-id="element-5078" data-mp="3r1fv4bdp6d88" />;
}